import { z } from 'zod';

// Every state a «Entrega» can be in, on `GET /app_service/panel/v1/deliveries/states` — the only
// source of the state filter's options, which is what makes an option that matches nothing
// structurally impossible.
//
// Route and envelope are GIVEN by backend, not proposed: a JSON object with the single key
// `states`, the shape the location search answers with, and NOT the `{count, results}` its
// building-scoped siblings use.
//
// `.strict()` where the carriers read has a `next: z.null().optional()`, and the difference is the
// missing `count`. With one known key there is nothing left to cross-check a truncated answer
// against, so anything added to the envelope later — `next`, `cursor`, `has_more` — would be
// dropped in silence and leave the dropdown offering half a catalog. A missing option reads to the
// agent as «this state does not exist», which is a wrong answer wearing the clothes of a right one.
// A loud parse failure is the cheaper outcome, and a nullable-cursor field would only catch a key
// spelled the way we guessed today.
//
// The entries are bare strings — the wire spellings — because the panel puts the labels on itself:
// the copy is product's, fixed, and resolved without this read.
export const DeliveryStatesResponseSchema = z
  .object({ states: z.array(z.string().min(1)) })
  .strict();

export type DeliveryStatesResponse = z.infer<typeof DeliveryStatesResponseSchema>;
